module.exports = __webpack_public_path__ + "img/印象丽江2_1.c63ed13a.jpg";